module.exports = __webpack_public_path__ + "img/scanner-touchscreen.79da7780.svg";